import { render, staticRenderFns } from "./EmployeeTaxCardsTableForm.vue?vue&type=template&id=c930163c&scoped=true&"
import script from "./EmployeeTaxCardsTableForm.vue?vue&type=script&lang=ts&"
export * from "./EmployeeTaxCardsTableForm.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeTaxCardsTableForm.vue?vue&type=style&index=0&id=c930163c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c930163c",
  null
  
)

export default component.exports